module.exports = __webpack_public_path__ + "img/ZB53详情页_05.1ddade2f.jpg";